import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { BreadcrumbService } from './breadcrumb.service';

export const provideBreadcrumb = (): EnvironmentProviders =>
  makeEnvironmentProviders([
    provideAppInitializer(() => {
      inject(BreadcrumbService);
    }),
  ]);
